// revit插件端初始化
import StorageUtils from './core/storageUtils'
import { InitDesktopClient } from '@/core/desktopUtils'
import { MessageBox } from 'element-ui'
import { Http } from '@/core/axios'
import { setForceLegacy as setForceLegacyInGcsUtils } from './core/gcsUtils'

export const initDesktop = function({ Vue, Store }, { platform, softwareCode, softwareVersion, language, isSelectingEquipment }) {
  return new Promise((resolve) => {
    InitDesktopClient((errorCode, errorMessage) => {
      if (errorCode === 'request.method.not.found') {
        MessageBox.confirm('您的插件版本可能较低, 建议升级后使用此功能！' + errorMessage, '提示', {
          type: 'warning',
          showCancelButton: false
        })
      }
    }).then(async(client) => {
      // 如果软件代码为 AppGbr，则需要转换为构件坞可识别的软件版本（2025.630-->2.7）
      console.log('softwareVersion', softwareVersion)
      const res = softwareCode === 'AppGbr' ? await Http.get('/data_standards/v1/software/software_versions', {
        software_code: softwareCode
      }) : []
      const matched = res.find((item) => item.displayVersion === softwareVersion) || {}
      softwareVersion = matched.softwareVersion || softwareVersion
      console.log('softwareVersion_updated', softwareVersion)

      Vue.prototype.$desktopClient = client
      const desktopInfo = await client.GetDesktopInfo()
      if (desktopInfo && desktopInfo.code === 'success') {
        StorageUtils.sessionStorage.set('desktopInfo', desktopInfo.data)
        Store.commit('setDesktopInfo', desktopInfo.data)
        if ((!softwareCode || !softwareVersion)) {
          const data = desktopInfo.data || {}
          softwareCode = data.hostAppName
          softwareVersion = data.hostAppVersion
        }
      }
      let localAppData = await client.GetSpecialFolder('LocalApplicationData')
      if (localAppData && localAppData.code === 'success') {
        localAppData = localAppData.data
      }
      StorageUtils.sessionStorage.set('softwareCode', softwareCode)
      StorageUtils.sessionStorage.set('softwareVersion', softwareVersion)
      StorageUtils.sessionStorage.set('language', language)
      StorageUtils.sessionStorage.set('localAppData', localAppData)
      Store.commit('setSoftwareCode', softwareCode)
      Store.commit('setSoftwareVersion', softwareVersion)
      Store.commit('setLanguage', language)
      Store.commit('setLocalAppData', localAppData)

      // G插件迁移后新增的逻辑（参考initGcs.js）
      if (platform === 'g' && softwareCode !== 'AppGbr') {
        // 1. 处理单设备选型
        if (isSelectingEquipment) {
          // 1.1 保存标记
          Store.commit('setIsSelectingEquipment', isSelectingEquipment)
          StorageUtils.sessionStorage.set('isSelectingEquipment', isSelectingEquipment)
          // 1.2 获取选型参数
          const selectionArgsRes = await client.GetBrowserCustomInputData()
          if (selectionArgsRes.code === 'success') {
            const selectionParams = {
              seltectdObjs: JSON.parse(selectionArgsRes.data)
            }
            Store.commit('setSelectionParams', selectionParams)
          }
        }

        // 2. 获取edition
        const editionRes = await client.GetHostEdition()
        const edition = editionRes ? editionRes.data : 'collaboration'
        Store.commit('setEdition', edition)
        console.info(`edition: ${edition}`)

        // 3. 获取fromEntrance
        const fromEntranceRes = await client.GetHostFromEntrance()
        const fromEntrance = fromEntranceRes ? fromEntranceRes.data : ''
        Store.commit('setFromEntrance', fromEntrance)
        console.info(`fromEntrance: ${fromEntrance}`)

        // 4. fastSearch相关
        const curveSearchValues = []
        const propertySearchValues = []
        Store.commit('fastSearch/setCurveSearchValues', curveSearchValues)
        Store.commit('fastSearch/setPropertySearchValues', propertySearchValues) // 处理列表页筛选条件组件中所需的初始值
      }
      /* 部分业务代码中，AppGbr竟然在调用gcsUtils.js,
      /* AppGbr插件是通过desktopUtils.js提供接口给web端使用的，因此web端不能调用gcsUtils.js, 没有报错只是因为gcsUtils.js捕获了异常,
      /* 此处通过禁止转接以保持旧状，以快速修复
      **/
      if (softwareCode === 'AppGbr') {
        setForceLegacyInGcsUtils(true)
      }

      resolve()
    })
  })
}
